export interface SendRequest {
    messageId: string;
    messageMarkDown?: string;
    to: string;
    from: string;
    chatWidgetId: string;
    actionId?: string;
    //metaItems?: MetaInfoData[];
    metaDataJson?: string;
}

// export interface MetaInfoData {
//     type: MetaInfoDataEnum;
//     dataJson: string;
// }

// export enum MetaInfoDataEnum {
//     Url = 0,
// }

// export interface MetaInfoDataUrl {
//     title: string;
//     url: string;
// }



export interface ChatWidgetActionRequest {
    messageId: string;
    sentDateAsTick: number;
    sentDate: Date;

    direction: CommunicationDirection;
    messageHtml?: string;
    chatWidgetId: string;
    ticketId: string;
    from: string;
    replyOptions?: ReplyOptionsData[];
    attachmentLinks?: AttachmentLink[];
    senderInfo?: SenderInfoData;
}


export interface ChatWidgetTypingRequest {
    id?: string;
    autoRemoveAfterReceiveMessage?: boolean;
    ticketId?: string;
    chatWidgetId?: string;
    typingUsers?: TypingUserData[];
    typingCommunicators?: TypingCommunicatorData[];
}
export interface TypingCommunicatorData {
    communicatorId: string;
}

export interface TypingUserData {
    userId: string;
    name?: string;
}


export interface SenderInfoData {
    name: string;
    avatarUrl?: string;
    senderId: string;
}

export interface AttachmentLink {
    fileDataId?: string;
    name?: string;
    url: string;
}

export enum CommunicationDirection {
    Unknown = 0,
    Inbound = 1,
    Outbound = 2,
}

export enum ReplyOptionType {
    ChoiceOption = 0,
    SummarizedItemOption = 1,
}

export interface ReplyOptionsData {
    type?: ReplyOptionType;
    data?: string;
}

export interface SummarizedItemOptionData {
    value?: string;
    buttonText?: string;
    name?: string;
    summaryHtml?: string;
}


export interface ChoiceOptionData {
    value?: string;
    text?: string;
}

export interface CallbackRequest {
    callbackId: string;
}

export interface ChatWidgetLobbySettingsData {
    title?: string;
    message?: string;
    messageHtml?: string | undefined;
    actionsStyling?: ChatWidgetStylingSettingsData;
    actions?: ChatWidgetActionItemData[];
}

export interface ChatWidgetPublicSettingsData {
    maxHeightPercentage?: number;
    maxWidth?: number;
    //fontFamily?: string;
    header?: ChatWidgetStylingSettingsData;
    styling?: ChatWidgetStylingSettingsData;
    lobby?: ChatWidgetLobbySettingsData;
    conversation?: ChatWidgetConversationSettingsData;
    opener?: ChatWidgetOpenerSettingData;
    title?: string;
    backgroundImageFileUrl?: string;
    allowFileUploads?: boolean;
    openingHours?: OpeningHoursData;
}

export interface OpeningHoursData {
    useOpeningHours?: boolean;
    monday?: OpeningHoursItem;
    tuesday?: OpeningHoursItem;
    wednesday?: OpeningHoursItem;
    thursday?: OpeningHoursItem;
    friday?: OpeningHoursItem;
    saturday?: OpeningHoursItem;
    sunday?: OpeningHoursItem;
}

export interface OpeningHoursItem {
    allDay?: boolean;
    fromUtcHours?: number;
    fromUtcMinutes?: number;
    toUtcHours?: number;
    toUtcMinutes?: number;
}

export interface ChatWidgetStylingSettingsData {
    showBackground?: boolean;
    backgroundColor?: string | undefined;
    foregroundColor?: string | undefined;
    borderRadius_LeftTop?: number;
    borderRadius_RightTop?: number;
    borderRadius_LeftBottom?: number;
    borderRadius_RightBottom?: number;
    borderRadius?: number;
    borderRadius_Linked?: boolean;
    showBorder?: boolean;
    borderColor?: string | undefined;
    useCustomPadding?: boolean;
    padding_LeftTop?: number;
    padding_RightTop?: number;
    padding_LeftBottom?: number;
    padding_RightBottom?: number;
    fontSize?: number | undefined;
    fontFamily?: string | undefined;
    dropShadow?: number | undefined;
}

export enum OpenerTypeEnum {
    Square = 0,
    Landscape = 1,
}
export interface ChatWidgetOpenerSettingData {
    styling?: ChatWidgetStylingSettingsData;
    backgroundImageFileUrl?: string;
    type?: OpenerTypeEnum;
    title?: string;
}

export interface ChatWidgetActionItemData {
    id: string;
    text?: string;
    data?: string;
    actionType?: ChatWidgetActionItemType;
}

export enum ChatWidgetActionItemType {
    StartFlow = 0,
}

export interface ChatWidgetConversationSettingsData {
    inboundMessageStyle?: ChatWidgetStylingSettingsData;
    outboundMessageStyle?: ChatWidgetStylingSettingsData;
    messageBoxStyle?: ChatWidgetStylingSettingsData;
    buttonsStyle?: ChatWidgetStylingSettingsData;
    messageActions?: ChatWidgetStylingSettingsData;
    showAvatars?: boolean;
    positionAllMessagesLeft?: boolean;
}
export interface AddBasicTicketEventRequest {
    chatWidgetId: string;
    to: string;
    ticketId?: string;
    eventData?: BasicTicketEvent;
}

export interface BasicTicketEvent {
    dateUtc?: Date;
    text?: string;
    imageUrl?: string;
    color?: ColorsEnum;
    buttons?: TicketEventButton[];
}

export interface TicketEventButton {
    url?: string;
    text?: string;
}


export enum ColorsEnum {
    Grey = 0,
    SubtleGreen = 1,
    Green = 2,
    BoldGreen = 3,
    SubtleYellow = 4,
    Yellow = 5,
    BoldYellow = 6,
    SubtleOrange = 7,
    Orange = 8,
    BoldOrange = 9,
    SubtleRed = 10,
    Red = 11,
    BoldRed = 12,
    SubtlePurple = 13,
    Purple = 14,
    BoldPurple = 15,
    SubtleBlue = 16,
    Blue = 17,
    BoldBlue = 18,
    SubtleSky = 19,
    Sky = 20,
    BoldSky = 21,
    SubtlePink = 22,
    Pink = 23,
    BoldPink = 24,
    SubtleBlack = 25,
    Black = 26,
    BoldBlack = 27,
    SubtleLime = 28,
    Lime = 29,
    BoldLime = 30,
}

export interface ChatWidgetTicketInfoRequest {
    ticketId?: string;
    chatWidgetId?: string;
}
